import { useState } from "react";

export default function usePagingState() {
    const [viewHeader, setViewHeader] = useState(true);
    return {
        viewHeader,
        setViewHeader,
    };
}
